// components/shared/modals/modalAplazar.jsx
import React, { useState, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { es } from 'date-fns/locale';
import { esES } from '@mui/x-date-pickers/locales';
import { format, parse, isValid, parseISO } from 'date-fns';
import { MODALS } from '../../../../config/images';
const EditDateSurvey = ({ showModal, closeModal, survey, onConfirm }) => {
  const [newClosingDate, setNewClosingDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (survey && survey.closing_At) {
      let dateToSet;
      
      try {
        dateToSet = parseISO(survey.closing_At);
        
        if (!isValid(dateToSet)) {
          dateToSet = parse(survey.closing_At, 'dd/MM/yyyy', new Date());
        }
        
        if (!isValid(dateToSet)) {
          dateToSet = new Date();
        }
        
        setNewClosingDate(dateToSet);
      } catch (error) {
        console.error('Error parsing date:', error);
        setNewClosingDate(new Date());
      }
    }
  }, [survey]);

  const handleConfirm = async () => {
    if (!newClosingDate) {
      setError('Por favor selecciona una nueva fecha de cierre');
      return;
    }

    if (!isValid(newClosingDate)) {
      setError('Fecha inválida');
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (newClosingDate < today) {
      setError('La fecha de cierre no puede ser anterior a hoy');
      return;
    }

    setLoading(true);
    try {
      await onConfirm(survey.id, format(newClosingDate, 'yyyy-MM-dd'));
      
    } catch (error) {
      setError('Error al actualizar la fecha');
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) return null;

  const sharedDateFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: 2,
    color: '#333',
    '& fieldset': {
      border: '1px solid #D1D5DB !important',
    },
    '&:hover fieldset': {
      border: '1px solid #D1D5DB !important',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #D1D5DB !important',
      boxShadow: 'none',
      outline: 'none',
    },
    },
  '& .MuiInputLabel-root': {
    fontSize: '0.875rem',
    '&.Mui-focused': {
      color: '#000',
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px 14px',
    fontSize: '0.875rem',
    color: '#000',
  },
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="md:w-[33%] w-[90%] bg-white rounded-xl ">
        <div className="flex justify-end w-full p-2">
          <button onClick={closeModal}>
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex flex-col gap-4 px-6 py-2 pb-6'>
            <h2 className="text-xl font-itcdemi text-blue">
              Aplazar fecha de encuesta
            </h2>
            
            <p className="text-gray-600 text-md font-itcbook">
              <strong>Encuesta:</strong> "{survey?.title}"
            </p>
    
            <div className='flex flex-col gap-2'>
                <p className='text-sm text-blue font-itcbook'>Fecha de fin: <span className="text-red-500">*</span></p>
                
                <LocalizationProvider 
                    dateAdapter={AdapterDateFns} 
                    adapterLocale={es} 
                    localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
                >
                    
                    <DatePicker
                        value={newClosingDate}
                        onChange={(date) => {
                            setNewClosingDate(date);
                            setError('');
                        }}
                        minDate={new Date()}
                        slotProps={{
                            textField: {
                            fullWidth: true,
                            size: 'small',
                            color:'inherit',
                            error: !!error,
                            helperText: error,
                            sx: sharedDateFieldSx,
                            },
                        }}
                    />
                </LocalizationProvider>
            </div>
    
    
            <button
                onClick={handleConfirm}
                disabled={loading}
                className="text-sm underline font-itcbook text-blue hover:text-blue-900 disabled:opacity-50 disabled:text-gray-400"
            >
                {loading ? 'Guardando...' : 'Aceptar'}
            </button>
            
        </div>
      </div>
    </div>
  );
};

export default EditDateSurvey;